import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Formik } from 'formik';
import Button from 'react-bootstrap/Button';
import { typeValidationSchema } from '../../validations-modules/asset.js'
import { FieldsAssetType } from '../fields-asset/FieldsAssetType.js'


export const FormAssetType = ({ formData, setFormData, nextStep, prevStep }) => {

  const [direction, setDirection] = useState('back');
  return (
    <>
      <Formik
        initialValues={formData}

        onSubmit={(values, {setSubmitting, resetForm}) => {
            // When button submits form and form is in the process of submitting, submit button is disabled
            setSubmitting(true);
            
            setFormData(prev => {
              return {...prev, ...values}
            });

            // Resets form after submission is complete
            resetForm();

            // Sets setSubmitting to false after form is reset
            setSubmitting(false);

            direction === 'back' ? prevStep() : nextStep();
        }}

        validationSchema={typeValidationSchema}
      >
        {({ isSubmitting, errors, touched, values, handleSubmit, resetForm, setFieldValue, setFieldTouched }) => 
        (
          <FieldsAssetType handleSubmit={handleSubmit} touched={touched} errors={errors} values={values} setFieldValue={setFieldValue} setFieldTouched={setFieldTouched}>      
                <Button
                  type='button'
                  variant='primary'
                  onClick={() => prevStep()} //we don't need to submit when we are going back in this page
                  disabled={isSubmitting}
                  className="mr-1">
                  Indietro
                </Button>
                <Button 
                  type='submit'
                  variant='primary'
                  onClick={() => setDirection('forward')}
                  disabled={isSubmitting}>
                  Avanti
                </Button>
          </FieldsAssetType>
        )}
      </Formik>
    </>
  );
};

FormAssetType.propTypes = {
  formData: PropTypes.object.isRequired,
  setFormData: PropTypes.func.isRequired,
  nextStep: PropTypes.func.isRequired,
  prevStep: PropTypes.func.isRequired
};